import { HIGHEST_NUMBER, PERCENT_DELTA, PERCENT_INPUT_TYPE, SALES_ASSOCIATE_DELTA, SALES_POSITION, UNIT_DELTA } from "./constants";
import { UpdateValueColumnArgs, UpdateValueRowArgs } from "./types";

export const getPositionInputDelta = (position = "", inputType = ""): number => {
	const isSalesPosition = position === SALES_POSITION;
	if (inputType === PERCENT_INPUT_TYPE) {
		return PERCENT_DELTA;
	}
	return isSalesPosition ? SALES_ASSOCIATE_DELTA : UNIT_DELTA;
};

export const isInfinityValue = (value = 0): boolean => {
	const absValue = Math.abs(value);
	return absValue === Infinity || absValue === HIGHEST_NUMBER;
};

export const updateHeaderColumnInput = (args: UpdateValueColumnArgs): void => {
	const { updatedModel, column, updatedValue, area, position, inputType, reset = false } = args;
	const delta = getPositionInputDelta(position, inputType);
	updatedModel.forEach((tier) => {
		tier.bonuses?.forEach((bonus: any, key: number) => {
			if(isInfinityValue(bonus[area]?.value)) return;
			if (area in bonus && key === column) {
				bonus[area]["value"] = updatedValue;
				if (tier.bonuses?.[key + 1] && area === "to") {
					tier.bonuses[key + 1]["from"]["value"] = (reset || updatedValue === 0) ? 0 : updatedValue - delta;
				}
			}
		});
	});
};

export const updateSideRowInput = (args: UpdateValueRowArgs): void => {
	const { updatedModel, row, column, updatedValue, area, position, inputType, reset = false } = args;
	const delta = getPositionInputDelta(position, inputType);
	if (area !== "bonus") {
		if(isInfinityValue(updatedModel[row][area]?.value)) return;
		updatedModel[row][area]["value"] = updatedValue;
		if (updatedModel?.[row + 1] && area === "to") {
			updatedModel[row + 1]["from"]["value"] = (reset || updatedValue === 0) ? 0 : updatedValue - delta;
		}
	} else {
		updatedModel[row]["bonuses"][column][area]["value"] = updatedValue;
	}
};
